<template>
  <div class='component-page'>
    <div class="edittable-table-height-con">
      <ul class='school-box'>
        <li>学校名称：{{schoolData.school_name}}</li>
        <li style='overflow:hidden'><span style='float:left'>所在省市：{{schoolData.province_name}}{{schoolData.city_name}}{{schoolData.area_name}}</span><span style='float:right'>教师人数：{{schoolData.teacher_num}}</span></li>
        <li style='overflow:hidden'><span style='float:left'>详细地址：{{schoolData.address}}</span><span style='float:right'>学生人数：{{schoolData.student_num}}</span></li>
        <li style='overflow:hidden'><span style='float:left'>邮箱：{{schoolData.email}}</span><span style='float:right'>班级数量：{{schoolData.class_num}}</span></li>
      </ul>
      <div class='money-box'>
        余额：{{schoolData.money}}￥
        <div class='recharge-btn'>
          <Button type="primary" ghost shape="circle" @click="recharge">充值</Button>
        </div>
      </div>
    </div>
    <Modal v-model="addModel" width="800" title="充值">
      <Form ref="formData" :model="formData" :rules="verificationRule" label-position="top">
  
        <FormItem label="充值金额" prop='money'>
          <Input v-model="formData.money" placeholder="请输入..."></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type='primary' ghost shape="circle" @click='orders'>确认下单</Button>
      </div>
    </Modal>
    <!--提醒弹层-->
    <Modal v-model="remindModal" width="440" class='remind'>
      <div class='remindContent'>
        {{remindContent}}
      </div>
      <div slot="footer">
        <Button type='primary' ghost shape="circle" @click='cancel'>关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<style lang="css">
  @import "../../common.css";
</style>

<style>
  .school-box {
    list-style-type: none;
    font-size: 16px;
    color: #333;
    width: 1000px;
    margin: 0 auto;
  }
  
  .school-box li {
    margin: 20px 0;
  }
  
  .money-box {
    width: 1000px;
    margin: 20px auto;
    font-size: 18px;
    color: #000;
  }
  
  .recharge-btn {
    float: right;
  }
</style>

<script>
  import axios from '@/libs/api.request'
  var qs = require('qs')
  
  export default {
    name: 'user-components',
  
    data() {
      return {
        schoolData: {},
        remindContent: '', //提醒内容
        remindModal: false, //提醒弹层状态
        formData: {
          money:'',
        },
        addModel: false,
        verificationRule: {
          proxy_name: [{
            required: true,
            message: '充值金额不能为空'
          }],
        },
      };
    },
    methods: {
      //获取列表数据
      getData() {
        this.$Loading.start();
          axios.request({
          url: '/home/info',
          data:{

          },
          method: 'post'
      }).then(res => {
          this.$Loading.finish();
          res = res.data;
          if (res.code == 200) {
            this.schoolData = res.data;
  
          } else if (res.code == 14001) {
  
            this.$Message.error(res.msg);
            this.$store.dispatch('handleLogOut').then(res => {
              this.$store.commit('clearOpenedSubmenu')
              this.$router.push({
                name: 'login'
              })
            })
          } else {
            this.$Message.error(res.msg);
          }
        })
      },
      orders() {
        axios.request({
          url: '/pay/create-order',
          data:{
              money:this.formData.money
          },
          method: 'post'
      }).then(res => {
          this.$Loading.finish();
          res = res.data;
          if (res.code == 200) {
           this.addModel = false;
            this.remindContent = '充值生成订单成功，请在校区订单管理页面进行支付';
            this.remindModal = true;
  
          } else if (res.code == 14001) {
  
            this.$Message.error(res.msg);
            this.$store.dispatch('handleLogOut').then(res => {
              this.$store.commit('clearOpenedSubmenu')
              this.$router.push({
                name: 'login'
              })
            })
          } else {
            this.$Message.error(res.msg);
          }
        })
        
  
      },
      recharge() {
        this.formData.money = '';
        this.addModel = true;
      },
      cancel() {
        this.remindModal = false;
  
      },
  
    },
    created() {
      this.getData();
  
  
    }
  };
</script>
